import { Icon, Typography } from "@/components/atoms";
import { useLayout } from "@/hooks";
import { clsx } from "@/utils";
import { useQuickSetupNavigation } from "../hooks";

export interface BackToQuickSetupBannerProps extends React.HTMLAttributes<HTMLDivElement> {}

export const BackToQuickSetupBanner = ({ className, ...props }: BackToQuickSetupBannerProps) => {
  const { cameFromQuickSetup, navigateToQuickSetup } = useQuickSetupNavigation();
  const {
    layout: { sidebarOpen },
  } = useLayout();

  if (!cameFromQuickSetup) return null;

  return (
    <div
      className={clsx(
        "relative top-0 z-40 flex min-h-16 cursor-pointer items-center justify-start gap-x-2 bg-info text-white sm:pl-[100px] lg:min-h-10 lg:pl-[120px]",
        { "sm:pl-[200px] lg:pl-[270px]": sidebarOpen },
        className
      )}
      onClick={navigateToQuickSetup}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigateToQuickSetup();
        }
      }}
      {...props}
    >
      <div className="mx-2 flex flex-row items-center gap-x-2.5">
        <Icon name="ArrowLeft" size="sm" className="flex-shrink-0" />
        <Typography variant="action">Back to Quick Setup</Typography>
      </div>
    </div>
  );
};
